import axios from 'axios'
import { cancelPreviousRequest } from '../../component/helper'

//import { ID, Response } from '../../../../../_metronic/helpers'
//import { User, UsersQueryResponse } from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const LEAD_LIST = `${API_URL}/lead-fresh-call`
const LEAD_DETAIL = `${API_URL}/lead-detail`
const All_FORMS = `${API_URL}/call-lock`
const RE_CALL_LIST = `${API_URL}/lead-recall`
const CLOSE_CALL_LIST = `${API_URL}/recent-close`
const CALL_PROGRESS_LIST = `${API_URL}/lead-progress`
const LEAD_SUBMIT = `${API_URL}/lead-submit`
const OTHER_FORM = `${API_URL}/other-form-submit`
const UNLOCK_CALL = `${API_URL}/unlock-call`
const CALL_HISTORY = `${API_URL}/call-history`
const CLOSE_DETAIL = `${API_URL}/call-close-detail`


const SUPPORT_CALL_LIST = `${API_URL}/support-fresh-call`
const SUPPORT_CALL_LOCK = `${API_URL}/support-call-lock`
const SUPPORT_RE_CALL_LIST = `${API_URL}/support-recall`
const SUPPORT_CLOSE_CALL_LIST = `${API_URL}/support-recent-close`
const SUPPORT_CALL_PROGRESS_LIST = `${API_URL}/support-progress-call`
const SUPPORT_CALL_SUBMIT = `${API_URL}/support-call-submit`
const SUPPORT_CALL_OTHER_FORM = `${API_URL}/support-other-form-submit`
const SUPPORT_UNLOCK_CALL = `${API_URL}/support-unlock-call`
const SUPPORT_SEARCH_CALL = `${API_URL}/support-search-call`
const DWONLOAD_FILE = `${API_URL}/dwonload_file`
const CALLING_ACTIVITY_ADD = `${API_URL}/calling-activity-add`
const COMPLAINT_SUBJECT = `${API_URL}/complaint-subject`
const COMPLAINT_ADD = `${API_URL}/complaint-add`
const COMPLAINT_LIST = `${API_URL}/complaint-list`
const COMPLAINT_USER = `${API_URL}/complaint-user`
const COMPLAINT_DETAIL = `${API_URL}/complaint-detail`
const COMPLAINT_UPDATE = `${API_URL}/complaint-updated`


const CALL_GENERATE = `${API_URL}/call-generate`
const GET_LANG = `${API_URL}/get-lang`
const CALLER_LANG = `${API_URL}/update-lead-lang`
const USER_BY_MOBILE = `${API_URL}/user-by-mobile`
const SKU_DETAIL_API = `${API_URL}/sku-detail-id`
const ORDER_DETAIL_API = `${API_URL}/order-user-detail`
const ORDER_USER_API = `${API_URL}/user-order-list`//order-sku-list
const ORDER_SKU_API = `${API_URL}/order-sku-list`//order-sku-list
const ADD_ORDER = `${API_URL}/add-order`
const NO_ORDER = `${API_URL}/no-order`
const COM_PROJECT = `${API_URL}/project-by-company`
const USER_LANG_UPDATE = `${API_URL}/user-lang-update`
const CHECK_CALL_UNLOCK = `${API_URL}/check_call_unlock`
const SEND_REDEMPTION_OTP = `${API_URL}/send-otp`
const SUPPORT_INBOUND_CALL = `${API_URL}/inbound_call`
const SUPPORT_UNREGITER_CALL = `${API_URL}/unrgister_call`
const PAN_VALIDATE = `${API_URL}/pan-validate-request`
const COM_PRODUCT_SEARCH = `${API_URL}/product-by-company`
const LEAD_CALL_LOCK = `${API_URL}/lead-call-lock`
const LEAD_RES_SAVE = `${API_URL}/lead-response-data`
const LEAD_CALL_FORM = `${API_URL}/lead-response-form`
const GET_DEALER_PINCODE = `${API_URL}/get-dealer-pincode`
const GET_VISIT = `${API_URL}/get-lead-visit`
const LEAD_OTHER_FORM_SUBMIT = `${API_URL}/lead-other-form-submit`
const LEAD_END_CALL = `${API_URL}/lead-end-call`

const LEAD_LIST_CALL = `${API_URL}/lead-call-list`
const LEAD_LIST_RECALL = `${API_URL}/lead-recall-list`
const LEAD_LIST_CALL_PROGRESS = `${API_URL}/lead-progress-call`
const LEAD_CLOSE_CALL = `${API_URL}/lead-recent-close`
const LEAD_REQUIREMENTS_PRODUCT_CAT = `${API_URL}/project-category-all-list`
const CALLING_DOCUMENT = `${API_URL}/get-calling-document`
const SEND_DOCUMENT = `${API_URL}/send-document`
const COMM_USER_CALL = `${API_URL}/comminication-calling-log`

const TELE_SUBJECT_BY_ID = `${API_URL}/telesubject-detail`
const TELE_SUBJECT_ALL = `${API_URL}/telesubject-all`
const TELE_SUBJECT_ADD = `${API_URL}/telesubject-add`
const TELE_SUBJECT_LIST = `${API_URL}/telesubject-list`
const TELE_SUBJECT_SUB = `${API_URL}/tele-subject-sub`
const USER_PERFORMANCE = `${API_URL}/user-performance`

const KOHLER_LEAD_RESPONSE = `${API_URL}/kohler-lead-response`

const SendMessageDealer = `${API_URL}/send-whatsapp-message-to-dealer`

const SALESFORCE_LIST = `${API_URL}/leads/salesforce-list`
const SALESFORCE_DETAIL = `${API_URL}/leads/salesforce-detail`
const MARK_LEAD_REPORTING_ADDED = `${API_URL}/mark-repoting-added`

const TELE_SUBJECT_SUB_BY_PROJECT_ID = `${API_URL}/tele-subject-sub-by-project`
export const sendMessageDealer = (query) => {
    return axios.post(SendMessageDealer, query).then((d) => d.data)
}
export const getLeadCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${LEAD_LIST_CALL}?${query}`, { signal }).then((d) => d.data)
}
export const getLeadReCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${LEAD_LIST_RECALL}?${query}`, { signal }).then((d) => d.data)
}
export const getLeadCallProgressList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${LEAD_LIST_CALL_PROGRESS}?${query}`, { signal }).then((d) => d.data)
}
export const getCloseCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${LEAD_CLOSE_CALL}?${query}`, { signal }).then((d) => d.data)
}


export const apiPanValidate = (query) => {
    return axios.post(PAN_VALIDATE, query).then((response) => response.data)
}
export const getLeadList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${LEAD_LIST}?${query}`, { signal }).then((d) => d.data)
}


export const getByLeadId = (id) => {
    return axios.get(`${LEAD_DETAIL}/${id}`).then((response) => response.data?.data)
}

export const getAllForm = (query) => {
    return axios.post(All_FORMS, query).then((response) => response.data?.data)
}

export const leadSubmited = (query) => {
    return axios.post(LEAD_SUBMIT, query).then((response) => response.data)
}
export const otherFormSubmited = (query) => {
    return axios.post(OTHER_FORM, query).then((response) => response.data)
}
export const callSubmited = (query) => {
    return axios.post(SUPPORT_CALL_SUBMIT, query).then((response) => response.data)
}

export const reCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${RE_CALL_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const progressCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${CALL_PROGRESS_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const closeCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${CLOSE_CALL_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const unlockCallList = (query) => {

    return axios.post(UNLOCK_CALL, query).then((response) => response.data)
}
/*** call support api */
export const getSupportList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${SUPPORT_CALL_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const getBySupportId = (id) => {
    return axios.get(`${LEAD_DETAIL}/${id}`).then((response) => response.data?.data)
}

export const getCallDetail = (query) => {
    return axios.post(SUPPORT_CALL_LOCK, query).then((response) => response.data?.data)
}
export const getLeadSaveResponse = (query) => {
    return axios.post(LEAD_RES_SAVE, query).then((response) => response.data)
}
export const getDealerByLeadID = (query) => {
    return axios.post(GET_DEALER_PINCODE, query).then((response) => response.data)
}
export const getVisitByLeadID = (query) => {
    return axios.post(GET_VISIT, query).then((response) => response.data)
}

export const getLeadCallDetail = (query) => {
    return axios.post(LEAD_CALL_LOCK, query).then((response) => response.data?.data)
}
export const getCallingDocument = (query) => {
    return axios.post(CALLING_DOCUMENT, query).then((response) => response.data?.data)
}


export const getLeadCallForm = (query) => {
    return axios.post(LEAD_CALL_FORM, query).then((response) => response.data?.data)
}
export const leadOtherFormSubmit = (query) => {
    return axios.post(LEAD_OTHER_FORM_SUBMIT, query).then((response) => response.data)
}
export const leadEndCall = (query) => {

    return axios.post(LEAD_END_CALL, query).then((response) => response.data)
}

export const addInboundCall = (query) => {
    return axios.post(SUPPORT_INBOUND_CALL, query).then((response) => response.data)
}

export const supportOtherFormSubmited = (query) => {
    return axios.post(SUPPORT_CALL_OTHER_FORM, query).then((response) => response.data)
}
export const supportReCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${SUPPORT_RE_CALL_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const supportProgressCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${SUPPORT_CALL_PROGRESS_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const supportCloseCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${SUPPORT_CLOSE_CALL_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const supportUnlockCallList = (query) => {

    return axios.post(SUPPORT_UNLOCK_CALL, query).then((response) => response.data)
}
export const searchInCall = (query) => {

    return axios.post(SUPPORT_SEARCH_CALL, query).then((response) => response.data)
}
export const historyCall = (query) => {
    return axios.post(CALL_HISTORY, query).then((response) => response.data)
}
export const getCloseDetail = (query) => {
    return axios.post(CLOSE_DETAIL, query).then((response) => response.data?.data)
}
export const dowloadFile = (query) => {
    return axios.post(DWONLOAD_FILE, query).then((response) => response.data)
}
export const callingActivityAdd = (query) => {
    return axios.post(CALLING_ACTIVITY_ADD, query).then((response) => response.data)
}

export const complaintSubjectList = () => {
    return axios.get(COMPLAINT_SUBJECT).then((response) => response.data)
}
export const complaintAdd = (query) => {
    return axios.post(COMPLAINT_ADD, query).then((response) => response.data)
}
export const complaintList = (query) => {
    return axios.get(`${COMPLAINT_LIST}?${query}`).then((d) => d.data)
}
export const complaintDetail = (id) => {
    return axios.get(`${COMPLAINT_DETAIL}/${id}`).then((d) => d.data)
}
export const complainUpdated = (query) => {
    return axios.post(COMPLAINT_UPDATE, query).then((d) => d.data)
}

export const complaintUserList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${COMPLAINT_USER}?${query}`, { signal }).then((response) => response.data)
}
export const commnicationUserList = (query) => {
    return axios.get(`${COMM_USER_CALL}?${query}`).then((response) => response.data)
}
export const callCreate = (query) => {
    return axios.post(CALL_GENERATE, query).then((response) => response?.data)
}
export const getLang = () => {
    return axios.get(GET_LANG).then((response) => response?.data)
}
export const updateCallerLang = (query) => {
    return axios.post(CALLER_LANG, query).then((response) => response?.data)
}
export const getUserByMobile = (query) => {
    return axios.post(USER_BY_MOBILE, query).then((response) => response?.data?.data)
}
export const getProductSkuCategory = (query) => {
    return axios.post(SKU_DETAIL_API, query).then((response) => response?.data?.data)
}
export const getOrderUserDetail = (query) => {
    return axios.post(ORDER_DETAIL_API, query).then((response) => response?.data)

}
export const addOrder = (query) => {
    return axios.post(ADD_ORDER, query).then((response) => response?.data)

}
export const getOrderSkuList = (query) => {
    return axios.get(`${ORDER_SKU_API}?${query}`).then((response) => response?.data)

}

export const getOrderUserList = (query) => {
    return axios.get(`${ORDER_USER_API}?${query}`).then((response) => response?.data)

}

export const getProjectByCompany = (query) => {
    return axios.post(COM_PROJECT, query).then((response) => response?.data?.data)

}
export const noOrder = (query) => {
    return axios.post(NO_ORDER, query).then((response) => response?.data)

}
export const getProductByCompany = (query) => {
    return axios.post(COM_PRODUCT_SEARCH, query).then((response) => response?.data?.data)

}

export const callerUserLangUpadte = (query) => {
    return axios.post(USER_LANG_UPDATE, query).then((response) => response?.data?.data)

}
export const checkCallLock = (query) => {
    return axios.post(CHECK_CALL_UNLOCK, query).then((response) => response?.data?.data)
}
export const sendRedemOtp = (query) => {
    return axios.post(SEND_REDEMPTION_OTP, query).then((response) => response?.data?.data)
}

export const unRagisterCall = (query) => {
    return axios.post(SUPPORT_UNREGITER_CALL, query).then((response) => response?.data)
}

export const leadRequirementsProductCat = (query) => {
    return axios.post(LEAD_REQUIREMENTS_PRODUCT_CAT, query).then((response) => response?.data)
}

export const sendDocument = (query) => {
    return axios.post(SEND_DOCUMENT, query).then((response) => response.data)
}
export const teleSubjectAdd = (query) => {
    return axios.post(TELE_SUBJECT_ADD, query).then((response) => response.data)
}
export const teleSubjectList = (query) => {
    return axios.get(`${TELE_SUBJECT_LIST}?${query}`).then((d) => d.data)
}
export const teleAllSubject = (query) => {
    return axios.get(`${TELE_SUBJECT_ALL}?${query}`).then((d) => d.data)
}
export const teleSubjectByID = (query) => {
    return axios.get(`${TELE_SUBJECT_BY_ID}/${query}`).then((d) => d.data?.data)
}
export const getTeleSubSubject = (query) => {
    return axios.post(TELE_SUBJECT_SUB, query).then((d) => d.data?.data)
}
export const getTeleSubSubjectByProjectId = (query) => {
    return axios.post(TELE_SUBJECT_SUB_BY_PROJECT_ID, query).then((d) => d.data?.data)
}
export const getUserPerformance = (query) => {
    return axios.post(USER_PERFORMANCE, query).then((d) => d.data?.data)
}
export const saveKohlerLeadResponse = (query) => {
    return axios.post(KOHLER_LEAD_RESPONSE, query).then((d) => d.data)
}

export const getSalesforceList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${SALESFORCE_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const getSalesforceDetail = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${SALESFORCE_DETAIL}?lead_id=${query}`, { signal }).then((d) => d.data)
}

export const markLeadReportingAdded = (query) => {
    return axios.post(MARK_LEAD_REPORTING_ADDED, query).then((response) => response.data)
}
